/**
 * Shared constants and helpers for AI modals (chat + onboarding).
 * Keeps drag-to-close, backdrop and transition behaviour identical and maintainable.
 */

/** Px drag down before we commit to close (same for both modals). */
export const DRAG_CLOSE_THRESHOLD = 100;

/** Ms to wait after setting exitY before calling close (panel slides off first). */
export const DRAG_EXIT_DELAY_MS = 300;

/** Backdrop fade-in on open (ms). */
export const BACKDROP_FADE_IN_MS = 180;

/** Backdrop closing transition duration (ms). */
export const BACKDROP_CLOSING_DURATION_MS = 280;

/** Outro when closing by drag: fade duration (ms). */
export const OUTRO_FADE_DURATION_MS = 200;

/** Outro when closing by button/backdrop: fly duration (ms). */
export const OUTRO_FLY_DURATION_MS = 250;

/** Outro fly Y offset (px). */
export const OUTRO_FLY_Y = 40;

/** Easing for drag-exit and backdrop-closing. */
export const EASING_EXIT = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

/** Default viewport height when SSR / no window. */
export const FALLBACK_VIEWPORT_HEIGHT = 800;

export function getExitY(): number {
	return typeof window !== 'undefined' ? window.innerHeight : FALLBACK_VIEWPORT_HEIGHT;
}

export function getBackdropBlurPx(dragOffset: number): number {
	if (typeof window === 'undefined') return 6;
	return Math.max(0, 6 - (dragOffset / window.innerHeight) * 6);
}

export function getBackdropBgIntensity(dragOffset: number): number {
	if (typeof window === 'undefined') return 1;
	return Math.max(0, 1 - dragOffset / window.innerHeight);
}
